// Central location for HELP (help.netius.com) links so we can update paths in one place.
export const HELP = {
  home: "https://help.netius.com",
  knowledgeBase: "https://help.netius.com/kb",
  submitTicket: "https://help.netius.com/tickets/new",
  status: "https://help.netius.com/status",
} as const;